jQuery(document).ready(function($) {

    // Attach updateOptions to the global window object
    window.setCustomDropDownOptions = function(dropdownId, newOptions) {
        var $dropdown = $(dropdownId);
        var $menu = $dropdown.find('.dropdown-menu');
        $menu.empty(); // Clear existing options

        // Populate with new options
        newOptions.forEach(function(option) {
            $menu.append($('<li>').attr('data-value', option.value).text(option.text));
        });

        // Optionally, update the visible part of the dropdown to the first option
        if (newOptions.length > 0) {
            $dropdown.find('.dropdown-toggle span').text(newOptions[0].text);
            $dropdown.find('.selected-value').val(newOptions[0].value);
        }
    };

    window.updateDropdown = function(dropdownInput, value) {

        // console.log(dropdownInput, value);

        // Find the parent dropdown container
        const dropdown = dropdownInput.closest('.custom-dropdown');
        const selectedItem = dropdown.find(`.dropdown-menu li[data-value="${value}"]`);

        if (selectedItem.length) {
            dropdown.find('.selected-value').val(value);
            dropdown.find('.dropdown-toggle span').text(selectedItem.text());
            // Make sure the dropdown is closed
            dropdown.find('.dropdown-menu').hide();
        } else {
            // If no matching value, perhaps set to a default or clear
            dropdown.find('.selected-value').val('');
            dropdown.find('.dropdown-toggle span').text('Select an option');
        }
    }

    function setMenuHeight(menuElement)
    {
        // Get the position of the menu element
        var position = menuElement.offset(); // This gives us the position relative to the document

        // Calculate the available space from the top of the element to the bottom of the screen
        var spaceBelow = ($(window).height() - (position.top - $(window).scrollTop()) - 40);

        // Adjust the height of the menu element based on available space below
        if (menuElement.outerHeight() > spaceBelow) {
            menuElement.css('height', spaceBelow + 'px'); // Set height to spaceBelow if the dropdown is taller than the space available
        } else {
            menuElement.css('height', 'auto'); // Set height to auto if there's enough space
        }
    }

    $('.custom-dropdown .dropdown-toggle').click(function() {
        // Close all other dropdown menus except for the current one
        $('.custom-dropdown .dropdown-menu').not($(this).next('.dropdown-menu')).hide();

        // Toggle the current dropdown menu
        $(this).next('.dropdown-menu').toggle();

        setMenuHeight($(this).next('.dropdown-menu'));
    });

    // Handle item clicks within the dropdown
    $(document).on('click', '.custom-dropdown .dropdown-menu li', function() {
        var value = $(this).data('value');
        var text = $(this).text();
        var dropdown = $(this).closest('.custom-dropdown');
        var input = dropdown.find('.selected-value');
        var toggle = dropdown.find('.dropdown-toggle span');

        input.val(value);  // Set the selected value
        toggle.text(text);  // Update the toggle button text
        dropdown.find('.dropdown-menu').hide();  // Close the dropdown menu

        // Trigger change event manually since .val() does not automatically trigger it
        input.trigger('change');
    });

    // Close dropdown when clicking outside
    $(document).click(function(event) {
        if (!$(event.target).closest('.custom-dropdown').length) {
            $('.custom-dropdown .dropdown-menu').hide();
        }
    });

});
